import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(()=>({
        listItem: {
            fontSize: 'inherit',
            color: 'inherit'
        }
    }));
const ListItem_styles = useStyles;
export default ListItem_styles;
